import type { ValidationReturn } from './types'

export const error = (message: string) => ({ message, type: 'error' } as ValidationReturn)
export const warning = (message: string) => ({ message, type: 'warning' } as ValidationReturn)
export const success = (message: string) => ({ message, type: 'success' } as ValidationReturn)
